import { render, staticRenderFns } from "./BusinessInvitationView.vue?vue&type=template&id=15498575&scoped=true&lang=pug&"
import script from "./BusinessInvitationView.vue?vue&type=script&lang=js&"
export * from "./BusinessInvitationView.vue?vue&type=script&lang=js&"
import style0 from "./BusinessInvitationView.vue?vue&type=style&index=0&id=15498575&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15498575",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
